export default __webpack_public_path__ + "static/media/inactiveIcon.425cf853.svg";